import {Form, FormDocument} from '../types/forms';
import {Project} from '../types/projects';
import {sortAlpha, sortAlphabetically} from '../utils/sortAlpha';
import {typeForm} from '../utils/typeForm';
import {instance} from './index';
import {getProjectsByIds} from './projectsService';

export async function getForms() {
  return instance()
    .get<Form[]>('/forms')
    .then(response => sortAlpha(response.data, 'name'));
}

export async function getFormsByIdProject(
  idOrganization: string,
  idProject: string,
) {
  return instance()
    .get<Form[]>('/forms', {
      params: {
        id_organization: idOrganization,
        id_project: idProject,
      },
    })
    .then(response => sortAlpha(response.data, 'name'));
}

export interface FormTable extends Form {
  projectName: string;
  typeFormName: string;
}

export async function getFormsByOrganization(idOrganization: string) {
  const [formsOrg] = await Promise.all([
    instance()
      .get<Form[]>(`/forms?id_organization=${idOrganization}`)
      .then(response => sortAlpha(response.data, 'name')),
  ]);

  const projectsIds = formsOrg.map((it: Form) => it.id_project);
  const projects = await getProjectsByIds(idOrganization, projectsIds);

  const data = [] as FormTable[];
  for (const form of formsOrg) {
    const project = projects.find(
      project => project.idProject === form.id_project,
    );

    if (!project) {
      continue;
    }

    data.push(
      mapForm({
        form,
        project,
      }),
    );
  }
  return data;
}

export interface IMapForm {
  project: Project;
  form: Form;
}

function mapForm(props: IMapForm): FormTable {
  const {form, project} = props;
  return {
    ...form,
    projectName: project.name,
    typeFormName: typeForm(form.typeForm),
  };
}

export async function getFormById(idForm: string) {
  return instance()
    .get<Form>(`/forms/${idForm}`)
    .then(response => response.data);
}

export async function getFormsByProject(idProject: string) {
  return instance()
    .get<Form[]>(
      `/forms?id_project=${idProject}&typeForm=event-form&typeForm=exam-form&isEnabled=true`,
    )
    .then(response => sortAlphabetically(response.data, 'name'));
}

// Formularios de venta de la org: alimentan el selector de la tabla de pedidos
// (cada pedido está ligado a un sale-form; sus respuestas se muestran como columnas).
export async function getSaleForms(idOrganization: string) {
  return instance()
    .get<Form[]>(
      `/forms?id_organization=${idOrganization}&typeForm=sale-form&isEnabled=true`,
    )
    .then(response => sortAlphabetically(response.data, 'name'));
}

export function createForm(data: Form) {
  return instance().post('/forms', data);
}

export function updateForm(data: Form) {
  return instance().put(`/forms/${data.id}`, data);
}

export async function getPreviewFormById(idForm: string) {
  return instance().get(`/docs-bridge/form/${idForm}/preview`, {
    responseType: 'blob',
  });
}

export async function getFileAnswers(idSet: string, idDocument: string) {
  return instance()
    .post<{fileUrl: string}>(
      `/docs-bridge/answer-set/${idSet}/document/${idDocument}`,
    )
    .then(response => response.data);
}

export async function getFormDocument(idForm: string) {
  return instance()
    .get<FormDocument[]>(`/docs-bridge/document-generator/${idForm}/documents`)
    .then(response => response.data);
}
